import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as lodash from 'lodash';
import { forkJoin, of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

@Injectable()
export class AppConfiguration {
  private configData: any;

  constructor(private _http: HttpClient) { }

  public getValue(key: string): any {
    if (this.configData) {
      let propertyValue = this.getNestedProperty(this.configData, key);
      if (propertyValue === undefined)
        return this.configData[key];
      else
        return this.configData[key] || this.getNestedProperty(this.configData, key);
    }
    return undefined;
  }

  public getValueByDossierType(dossierType: string, key: string) {
    if (this.configData) {
      let dossierConfig = this.getValue('dossierConfig.' + dossierType);
      let defaultDossierConfig = this.getValue('dossierConfig.DEFAULT');

      let propertyValue = null;
      if (dossierConfig) {
        propertyValue = this.getNestedProperty(dossierConfig, key);
        if (propertyValue === undefined) {
          propertyValue = dossierConfig[key];
        }
      }

      // si no se ha encontrado propiedad, buscamos en la configuracion DEFAULT
      if (propertyValue == undefined) {
        propertyValue = this.getNestedProperty(defaultDossierConfig, key);
        if (propertyValue === undefined) {
          propertyValue = defaultDossierConfig[key];
        }
      }
      return propertyValue;
    }
    return undefined;
  }

  // This is the method you want to call at bootstrap
  // Important: It should return a Promisex
  load(): Promise<any> {
    let promise: Promise<any> = new Promise((resolve: any) => {
      forkJoin(
        this._http.get('assets/config/config.json'),
        this._http.get('assets/config/adapt/config.json').pipe(
          catchError((error: any) => {
            console.log('Error al cargar configuracion de la adaptacion', error);
            return of(undefined);
          })
        )
      ).pipe(take(1)).subscribe((result: any[]) => {
        if (result[1]) {
          // https://stackoverflow.com/questions/53706122/use-mergewith-of-lodash-with-nested-objects
          const customizer = (a, b, c) => lodash.defaultTo(this.mix(a, b, c), undefined)
          this.configData = lodash.mergeWith(result[0], result[1], customizer);
        } else {
          this.configData = result[0];
        }
        resolve(true);
      });
    });
    return promise;
  }

  private mix(product, adapt, propertyName) {
    if (adapt != undefined) {
      if (lodash.isObject(adapt) && !lodash.isArray(adapt)) {
        let ret = lodash.merge(product, adapt);
        return ret;
      }
      return adapt;
    } else {
      return product;
    }

  }

  private getNestedProperty(object, property) {
    let ret;
    if (object && typeof object === 'object') {
      if (typeof property === 'string' && property !== '') {
        // Se modifican las posiciones de arrays numericas
        let modifiedProperty = property.replace(/\[(\d+)\]/g, '.$1')
        let split = modifiedProperty.split('.');
        ret = split.reduce(function (obj, prop) {
          return obj && obj[prop];
        }, object);
      } else if (typeof property === 'number') {
        ret = object[property];
      } else {
        ret = object;
      }
    } else {
      ret = object;
    }
    //    console.log('getNestedProperty', property, ret);
    return ret;
  }
}
